var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"right":"","color":_vm.statusColor}},[_vm._v(_vm._s(_vm.statusIcon))])}
var staticRenderFns = []

export { render, staticRenderFns }